"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ManagePowerUpLicense = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var trello_1 = require("@powerupsclub/trello");
var react_1 = require("react");
var avatar_1 = __importDefault(require("@atlaskit/avatar"));
var button_1 = __importDefault(require("@atlaskit/button"));
var contexts_1 = require("../../contexts");
var ManagePowerUpLicense = function (_a) {
    var numberOfWorkspaceMembers = _a.numberOfWorkspaceMembers;
    var _b = (0, react_1.useContext)(trello_1.TrelloPowerUpContext), me = _b.me, trelloIframe = _b.trelloIframe, org = _b.org, members = _b.members, powerUpKey = _b.powerUpKey, appName = _b.appName;
    var _c = (0, react_1.useContext)(contexts_1.PaymentsContext), subscription = _c.subscription, makePortalSession = _c.makePortalSession;
    var powerUpLicense = subscription[powerUpKey];
    if (!powerUpLicense) {
        return null;
    }
    var individual = powerUpLicense.individual, workspace = powerUpLicense.workspace;
    var workspacePayer = (workspace === null || workspace === void 0 ? void 0 : workspace.status) === 'active'
        ? members.find(function (m) { return m.id === workspace.idMemberPayer; })
        : null;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(workspace === null || workspace === void 0 ? void 0 : workspace.status) === 'active' && ((0, jsx_runtime_1.jsx)("div", __assign({ style: {
                    borderRadius: '4px',
                    backgroundColor: '#fff280',
                    padding: '8px',
                    textAlign: 'center',
                    fontWeight: 500,
                    marginBottom: '16px',
                    color: 'black'
                } }, { children: trelloIframe.localizeKey('the-workspace-has-a-powerup-license', {
                    workspaceName: org.name,
                    powerUpName: appName
                }) }), void 0)), workspacePayer && ((0, jsx_runtime_1.jsxs)("div", __assign({ style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    marginTop: '12px'
                } }, { children: [(0, jsx_runtime_1.jsx)("div", { children: trelloIframe.localizeKey('this-workspace-license-is-managed-by') }, void 0), (0, jsx_runtime_1.jsxs)("div", __assign({ style: {
                            padding: '8px 0',
                            textAlign: 'center'
                        } }, { children: [(0, jsx_runtime_1.jsx)(avatar_1["default"], { src: workspacePayer.avatar, size: "xsmall" }, void 0), ' ', (0, jsx_runtime_1.jsx)("b", { children: workspacePayer.fullName }, void 0)] }), void 0)] }), void 0)), (individual === null || individual === void 0 ? void 0 : individual.status) === 'active' && ((0, jsx_runtime_1.jsx)("div", __assign({ style: {
                    borderRadius: '4px',
                    backgroundColor: '#fff280',
                    padding: '8px',
                    textAlign: 'center',
                    fontWeight: 500,
                    marginBottom: '16px',
                    color: 'black'
                } }, { children: trelloIframe.localizeKey('you-have-an-active-powerup-license', {
                    powerUpName: appName
                }) }), void 0)), ((workspacePayer === null || workspacePayer === void 0 ? void 0 : workspacePayer.id) === (me === null || me === void 0 ? void 0 : me.id) || (individual === null || individual === void 0 ? void 0 : individual.status) === 'active') && ((0, jsx_runtime_1.jsx)(button_1["default"], __assign({ shouldFitContainer: true, onClick: function () {
                    makePortalSession()
                        .then(function (session) {
                        window.open(session.url, '_blank');
                    })["catch"](function (error) {
                        trelloIframe.alert({
                            message: 'Something went wrong. Please try again or contact support.'
                        });
                    });
                } }, { children: trelloIframe.localizeKey('manage-subscription') }), void 0))] }, void 0));
};
exports.ManagePowerUpLicense = ManagePowerUpLicense;
//# sourceMappingURL=ManagePowerUpLicense.js.map